import {
  protoOf180f3jzyo7rfj as protoOf,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  Long2qws0ah9gnpki as Long,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  VOID7hggqo3abtya as VOID,
  Unit_instance104q5opgivhr8 as Unit_instance,
  objectCreate1ve4bgxiu4x98 as objectCreate,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  Enum3alwj03lh1n41 as Enum,
  CoroutineImpl2sn3kjnwmfr10 as CoroutineImpl,
  KtList3hktaavzmj137 as KtList,
  isInterface3d6p8outrmvmk as isInterface,
  get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  Result3t1vadv16kmzk as Result,
  Companion_instance3fplhgf4ipvld as Companion_instance,
  _Result___init__impl__xyqfz81wclroc5pw7j2 as _Result___init__impl__xyqfz8,
  createFailure8paxfkfa5dc7 as createFailure,
  CancellationException3b36o9qz53rgr as CancellationException,
  Result__exceptionOrNull_impl_p6xea9boty10p2dkn4 as Result__exceptionOrNull_impl_p6xea9,
  _Result___get_value__impl__bjfvqgo6z1uu11rodr as _Result___get_value__impl__bjfvqg,
  getKClass1s3j9wy1cofik as getKClass,
  arrayOf1akklvh2at202 as arrayOf,
  createKType1lgox3mzhchp5 as createKType,
  createInvariantKTypeProjection3sfd0u0y62ozd as createInvariantKTypeProjection,
  Unitkvevlwgzwiuc as Unit,
  getValue48kllevslyh6 as getValue,
  equals2au1ep9vhcato as equals,
  initMetadataForCoroutine1i7lbatuf5bnt as initMetadataForCoroutine,
  emptyList1g2z5xcrvp2zy as emptyList,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
} from './kotlin-kotlin-stdlib.mjs';
import {
  PluginGeneratedSerialDescriptorqdzeg5asqhfg as PluginGeneratedSerialDescriptor,
  UnknownFieldException_init_$Create$1mnsp66c6fnup as UnknownFieldException_init_$Create$,
  LongSerializer_getInstance3iic24guzegu7 as LongSerializer_getInstance,
  typeParametersSerializers2likxjr48tr7y as typeParametersSerializers,
  GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer,
  throwMissingFieldException2cmke0v3ynf14 as throwMissingFieldException,
  serializer1hwzc6m64v1op as serializer,
  KSerializerzf77vz1967fq as KSerializer,
  LIST_getInstance3iji3zetpdcxm as LIST_getInstance,
  SerializationExceptioneqrdve3ts2n9 as SerializationException,
} from './kotlinx-serialization-kotlinx-serialization-core.mjs';
import {
  SimpleListEndpointCacheStrategy1m0xsspwu4sws as SimpleListEndpointCacheStrategy,
  Companion_instance38at02i5wbrbj as Companion_instance_0,
  UnexpectedApiResponse11rd45rhjxm6r as UnexpectedApiResponse,
  IListLocalSource39ga4nlfbxuv1 as IListLocalSource,
  ISessionDataProvidercfh7rhcdvasx as ISessionDataProvider,
  SimpleListCacheLocalSource9ig3nhg8ocnr as SimpleListCacheLocalSource,
} from './Shared7Punches-common-base.mjs';
import {
  Companion_getInstance35hsivaslc5e3 as Companion_getInstance,
  ApiVersion_FEBRUARY_2026_getInstancexhgc3m6uvy4r as ApiVersion_FEBRUARY_2026_getInstance,
  buildV2Path1ie1ylvss3rsk as buildV2Path,
  mapApiErrorResponse18m737xo6p7hy as mapApiErrorResponse,
  get_sharedJson2ja82jrdlkmvt as get_sharedJson,
  Clientssjxb7gh2u6y as Client,
} from './Shared7Punches-infrastructure-network.mjs';
import {
  HttpRequestBuilder15f2nnx9sjuv1 as HttpRequestBuilder,
  url2l6iw5ri21nxb as url,
  headers24pki7ce1busg as headers,
  HttpStatement3zxb33q8lku as HttpStatement,
} from './ktor-ktor-client-ktor-client-core.mjs';
import { Companion_getInstancepumzx9q4106p as Companion_getInstance_0 } from './ktor-ktor-http.mjs';
import {
  JsonElementf07o4p6p57al as JsonElement,
  JsonObjectee06ihoeeiqj as JsonObject,
  JsonArray2urf8ey7u44sd as JsonArray,
} from './kotlinx-serialization-kotlinx-serialization-json.mjs';
import { TypeInfo2nbxsuf4v8os2 as TypeInfo } from './ktor-ktor-utils.mjs';
import {
  Companion_getInstance1rlvzabi952im as Companion_getInstance_1,
  Kind_Factory_getInstance2ge7vb99ubfwr as Kind_Factory_getInstance,
  BeanDefinitionhif1nxb54kgk as BeanDefinition,
  FactoryInstanceFactory2tq2q9e5id3pz as FactoryInstanceFactory,
  KoinDefinition2pr0kscd0vkk6 as KoinDefinition,
  TypeQualifier1esmq2h0dalsb as TypeQualifier,
  Kind_Singleton_getInstance2ue26e37jajuw as Kind_Singleton_getInstance,
  SingleInstanceFactoryp594z6t2b69a as SingleInstanceFactory,
  binds4rk2rn2wwzpn as binds,
  module39wmcymxxg0fj as module_0,
} from './projects-core-koin-core.mjs';
import { ICache3bwileb79diof as ICache } from './Shared7Punches-infrastructure-cache.mjs';
//region block: imports
//endregion
//region block: pre-declaration
initMetadataForCompanion(Companion);
initMetadataForObject($serializer, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(ApiTimeOff, 'ApiTimeOff', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance});
initMetadataForClass(ApiTimeOffStatus, 'ApiTimeOffStatus', VOID, Enum);
initMetadataForLambda(TimeOffRepository$cacheStrategy$slambda, CoroutineImpl, VOID, [1]);
initMetadataForLambda(TimeOffRepository$cacheStrategy$slambda_1, CoroutineImpl, VOID, [0]);
initMetadataForInterface(ITimeOffAccessor, 'ITimeOffAccessor');
initMetadataForInterface(ITimeOffMutator, 'ITimeOffMutator', VOID, VOID, VOID, [2, 1]);
initMetadataForClass(TimeOffRepository, 'TimeOffRepository', VOID, VOID, [ITimeOffAccessor, ITimeOffMutator], [2, 1]);
initMetadataForCoroutine($getTimeOffRequestsCOROUTINE$3, CoroutineImpl);
initMetadataForClass(TimeOffRemoteSource, 'TimeOffRemoteSource', VOID, VOID, VOID, [1, 2]);
initMetadataForClass(TimeOff, 'TimeOff');
//endregion
function toDomain(_this__u8e3s4) {
  return new TimeOff(_this__u8e3s4.q88_1);
}
function Companion() {
}
var Companion_instance_1;
function Companion_getInstance_2() {
  return Companion_instance_1;
}
function $serializer() {
  $serializer_instance = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.sevenshifts.shared.data.timeoff.data.model.ApiTimeOff', this, 1);
  tmp0_serialDesc.wy('id', false);
  this.r88_1 = tmp0_serialDesc;
}
protoOf($serializer).s88 = function (encoder, value) {
  var tmp0_desc = this.r88_1;
  var tmp1_output = encoder.kr(tmp0_desc);
  tmp1_output.vs(tmp0_desc, 0, value.q88_1);
  tmp1_output.lr(tmp0_desc);
};
protoOf($serializer).yn = function (encoder, value) {
  return this.s88(encoder, value instanceof ApiTimeOff ? value : THROW_CCE());
};
protoOf($serializer).zn = function (decoder) {
  var tmp0_desc = this.r88_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = new Long(0, 0);
  var tmp5_input = decoder.kr(tmp0_desc);
  if (tmp5_input.as()) {
    tmp4_local0 = tmp5_input.qr(tmp0_desc, 0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp5_input.bs(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp5_input.qr(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp5_input.lr(tmp0_desc);
  return ApiTimeOff_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
};
protoOf($serializer).xn = function () {
  return this.r88_1;
};
protoOf($serializer).pz = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [LongSerializer_getInstance()];
};
var $serializer_instance;
function $serializer_getInstance() {
  if ($serializer_instance == null)
    new $serializer();
  return $serializer_instance;
}
function ApiTimeOff_init_$Init$(seen0, id, serializationConstructorMarker, $this) {
  if (!(1 === (1 & seen0))) {
    throwMissingFieldException(seen0, 1, $serializer_getInstance().r88_1);
  }
  $this.q88_1 = id;
  return $this;
}
function ApiTimeOff_init_$Create$(seen0, id, serializationConstructorMarker) {
  return ApiTimeOff_init_$Init$(seen0, id, serializationConstructorMarker, objectCreate(protoOf(ApiTimeOff)));
}
function ApiTimeOff(id) {
  this.q88_1 = id;
}
protoOf(ApiTimeOff).toString = function () {
  return 'ApiTimeOff(id=' + this.q88_1.toString() + ')';
};
protoOf(ApiTimeOff).hashCode = function () {
  return this.q88_1.hashCode();
};
protoOf(ApiTimeOff).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof ApiTimeOff))
    return false;
  var tmp0_other_with_cast = other instanceof ApiTimeOff ? other : THROW_CCE();
  if (!this.q88_1.equals(tmp0_other_with_cast.q88_1))
    return false;
  return true;
};
var ApiTimeOffStatus_PENDING_instance;
var ApiTimeOffStatus_APPROVED_instance;
var ApiTimeOffStatus_DECLINED_instance;
var ApiTimeOffStatus_UNKNOWN_instance;
var ApiTimeOffStatus_entriesInitialized;
function ApiTimeOffStatus_initEntries() {
  if (ApiTimeOffStatus_entriesInitialized)
    return Unit_instance;
  ApiTimeOffStatus_entriesInitialized = true;
  ApiTimeOffStatus_PENDING_instance = new ApiTimeOffStatus('PENDING', 0, 0);
  ApiTimeOffStatus_APPROVED_instance = new ApiTimeOffStatus('APPROVED', 1, 1);
  ApiTimeOffStatus_DECLINED_instance = new ApiTimeOffStatus('DECLINED', 2, 2);
  ApiTimeOffStatus_UNKNOWN_instance = new ApiTimeOffStatus('UNKNOWN', 3, -1);
}
function ApiTimeOffStatus(name, ordinal, apiValue) {
  Enum.call(this, name, ordinal);
  this.v88_1 = apiValue;
}
function ApiTimeOffStatus_PENDING_getInstance() {
  ApiTimeOffStatus_initEntries();
  return ApiTimeOffStatus_PENDING_instance;
}
function TimeOffRepository$cacheStrategy$slambda(this$0, resultContinuation) {
  this.e89_1 = this$0;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(TimeOffRepository$cacheStrategy$slambda).g89 = function (it, $completion) {
  var tmp = this.h89(it, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
};
protoOf(TimeOffRepository$cacheStrategy$slambda).h9 = function (p1, $completion) {
  return this.g89((!(p1 == null) ? isInterface(p1, KtList) : false) ? p1 : THROW_CCE(), $completion);
};
protoOf(TimeOffRepository$cacheStrategy$slambda).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 2;
          this.n8_1 = 1;
          suspendResult = this.e89_1.j89_1.m2u(this.f89_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          return Unit_instance;
        case 2:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 2) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
protoOf(TimeOffRepository$cacheStrategy$slambda).h89 = function (it, completion) {
  var i = new TimeOffRepository$cacheStrategy$slambda(this.e89_1, completion);
  i.f89_1 = it;
  return i;
};
function TimeOffRepository$cacheStrategy$slambda_0(this$0, resultContinuation) {
  var i = new TimeOffRepository$cacheStrategy$slambda(this$0, resultContinuation);
  var l = function (it, $completion) {
    return i.g89(it, $completion);
  };
  l.$arity = 1;
  return l;
}
function TimeOffRepository$cacheStrategy$slambda_1(this$0, resultContinuation) {
  this.t89_1 = this$0;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(TimeOffRepository$cacheStrategy$slambda_1).u89 = function ($completion) {
  var tmp = this.m32($completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  var tmp_0 = tmp.v8();
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    return tmp_0;
  return tmp_0;
};
protoOf(TimeOffRepository$cacheStrategy$slambda_1).ma = function ($completion) {
  return this.u89($completion);
};
protoOf(TimeOffRepository$cacheStrategy$slambda_1).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 3;
          this.n8_1 = 1;
          suspendResult = this.t89_1.i89_1.x89(ApiTimeOffStatus_PENDING_getInstance(), this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          this.n8_1 = 2;
          continue $sm;
        case 1:
          var unboxed = suspendResult.ul_1;
          suspendResult = new Result(unboxed);
          this.n8_1 = 2;
          continue $sm;
        case 2:
          return suspendResult;
        case 3:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 3) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
protoOf(TimeOffRepository$cacheStrategy$slambda_1).m32 = function (completion) {
  return new TimeOffRepository$cacheStrategy$slambda_1(this.t89_1, completion);
};
function TimeOffRepository$cacheStrategy$slambda_2(this$0, resultContinuation) {
  var i = new TimeOffRepository$cacheStrategy$slambda_1(this$0, resultContinuation);
  var l = function ($completion) {
    return i.u89($completion);
  };
  l.$arity = 0;
  return l;
}
function TimeOffRepository$cacheStrategy$lambda(it) {
  return toDomain(it);
}
function TimeOffRepository$cacheStrategy$lambda_0($this$SimpleListEndpointCacheStrategy) {
  return $this$SimpleListEndpointCacheStrategy.y89_1;
}
function TimeOffRepository(remoteSource, localSource) {
  this.i89_1 = remoteSource;
  this.j89_1 = localSource;
  var tmp = this;
  var tmp_0 = this.j89_1.n18();
  var tmp_1 = TimeOffRepository$cacheStrategy$slambda_0(this, null);
  var tmp_2 = TimeOffRepository$cacheStrategy$slambda_2(this, null);
  var tmp_3 = TimeOffRepository$cacheStrategy$lambda;
  tmp.k89_1 = new SimpleListEndpointCacheStrategy(tmp_0, tmp_1, tmp_2, tmp_3, TimeOffRepository$cacheStrategy$lambda_0);
}
function TimeOffRemoteSource$getTimeOffRequests$lambda($companyId, $status) {
  return function ($this$get, it) {
    $this$get.o44_1.r3q('company_id', $companyId.toString());
    var tmp0_safe_receiver = $status;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      $this$get.o44_1.r3q('status', tmp0_safe_receiver.v88_1.toString());
    }
    return Unit_instance;
  };
}
function TimeOffRemoteSource$getTimeOffRequests$lambda_0($apiVersion) {
  return function ($this$headers) {
    Companion_getInstance().x6l($this$headers, $apiVersion);
    return Unit_instance;
  };
}
function $getTimeOffRequestsCOROUTINE$3(_this__u8e3s4, status, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.h8a_1 = _this__u8e3s4;
  this.i8a_1 = status;
}
protoOf($getTimeOffRequestsCOROUTINE$3).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 13;
          this.n8_1 = 1;
          suspendResult = this.h8a_1.w89_1.e2w(this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          this.j8a_1 = suspendResult;
          var tmp_0 = this;
          tmp_0.k8a_1 = this.h8a_1.v89_1;
          var tmp_1 = this;
          tmp_1.l8a_1 = 'time_off';
          var tmp_2 = this;
          tmp_2.m8a_1 = ApiVersion_FEBRUARY_2026_getInstance();
          var tmp_3 = this;
          tmp_3.n8a_1 = TimeOffRemoteSource$getTimeOffRequests$lambda(this.j8a_1, this.i8a_1);
          this.o8a_1 = this.k8a_1;
          this.p8a_1 = this.l8a_1;
          this.q8a_1 = this.m8a_1;
          this.r8a_1 = this.n8a_1;
          this.o8_1 = 3;
          var tmp_4 = this;
          tmp_4.t8a_1 = Companion_instance;
          var tmp_5 = this;
          tmp_5.u8a_1 = this.o8a_1.f6l_1;
          var tmp_6 = this;
          tmp_6.v8a_1 = buildV2Path(this.o8a_1, this.p8a_1);
          this.w8a_1 = this.u8a_1;
          this.x8a_1 = this.v8a_1;
          var tmp_7 = this;
          tmp_7.y8a_1 = this.w8a_1;
          this.z8a_1 = this.y8a_1;
          var tmp_8 = this;
          tmp_8.a8b_1 = this.z8a_1;
          var tmp_9 = this;
          var this_0 = new HttpRequestBuilder();
          url(this_0, this.x8a_1);
          headers(this_0, TimeOffRemoteSource$getTimeOffRequests$lambda_0(this.q8a_1));
          this_0.z5n(this.r8a_1);
          tmp_9.b8b_1 = this_0;
          this.c8b_1 = this.a8b_1;
          this.d8b_1 = this.b8b_1;
          this.d8b_1.q4r_1 = Companion_getInstance_0().f41_1;
          var tmp_10 = this;
          tmp_10.e8b_1 = this.c8b_1;
          var tmp_11 = this;
          tmp_11.f8b_1 = this.d8b_1;
          this.g8b_1 = this.e8b_1;
          this.h8b_1 = this.f8b_1;
          this.n8_1 = 2;
          suspendResult = (new HttpStatement(this.h8b_1, this.g8b_1)).e5t(this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 2:
          this.i8b_1 = suspendResult;
          var tmp_12 = this;
          this.t8a_1;
          var value = this.i8b_1;
          tmp_12.s8a_1 = _Result___init__impl__xyqfz8(value);
          this.o8_1 = 13;
          this.n8_1 = 4;
          continue $sm;
        case 3:
          this.o8_1 = 13;
          var tmp_13 = this.q8_1;
          if (tmp_13 instanceof CancellationException) {
            this.j8b_1 = this.q8_1;
            var tmp_14 = this;
            throw this.j8b_1;
          } else {
            var tmp_15 = this.q8_1;
            if (tmp_15 instanceof Error) {
              this.k8b_1 = this.q8_1;
              var tmp_16 = this;
              var exception = this.k8b_1;
              tmp_16.s8a_1 = _Result___init__impl__xyqfz8(createFailure(exception));
              this.n8_1 = 4;
              continue $sm;
            } else {
              throw this.q8_1;
            }
          }

        case 4:
          this.o8_1 = 13;
          this.l8b_1 = this.s8a_1;
          this.m8b_1 = this.l8b_1;
          this.n8b_1 = Result__exceptionOrNull_impl_p6xea9(this.m8b_1);
          if (this.n8b_1 == null) {
            var tmp_17 = this;
            var tmp_18 = _Result___get_value__impl__bjfvqg(this.m8b_1);
            tmp_17.p8b_1 = (tmp_18 == null ? true : !(tmp_18 == null)) ? tmp_18 : THROW_CCE();
            this.q8b_1 = this.p8b_1;
            var tmp_19 = this;
            tmp_19.r8b_1 = this.q8b_1;
            this.s8b_1 = this.r8b_1;
            this.t8b_1 = this.s8b_1.c4u().z43_1;
            var containsArg = this.t8b_1;
            if (200 <= containsArg ? containsArg <= 299 : false) {
              this.o8_1 = 9;
              var tmp_20 = this;
              tmp_20.w8b_1 = Companion_instance;
              if (getKClass(KtList).equals(getKClass(Unit))) {
                var tmp_21 = this;
                tmp_21.y8b_1 = this.s8b_1;
                this.z8b_1 = this.y8b_1;
                this.n8_1 = 7;
                var tmp_22 = this.z8b_1.y4u();
                var tmp_23 = getKClass(KtList);
                var tmp_24;
                try {
                  tmp_24 = createKType(getKClass(KtList), arrayOf([createInvariantKTypeProjection(createKType(getKClass(ApiTimeOff), arrayOf([]), false))]), false);
                } catch ($p) {
                  var tmp_25;
                  if ($p instanceof Error) {
                    var _unused_var__etf5q3 = $p;
                    tmp_25 = null;
                  } else {
                    throw $p;
                  }
                  tmp_24 = tmp_25;
                }
                suspendResult = tmp_22.a4u(new TypeInfo(tmp_23, tmp_24), this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                var tmp_26 = this;
                tmp_26.a8c_1 = this.s8b_1;
                this.b8c_1 = this.a8c_1;
                this.n8_1 = 6;
                var tmp_27 = this.b8c_1.y4u();
                var tmp_28 = getKClass(JsonElement);
                var tmp_29;
                try {
                  tmp_29 = createKType(getKClass(JsonElement), arrayOf([]), false);
                } catch ($p) {
                  var tmp_30;
                  if ($p instanceof Error) {
                    var _unused_var__etf5q3_0 = $p;
                    tmp_30 = null;
                  } else {
                    throw $p;
                  }
                  tmp_29 = tmp_30;
                }
                suspendResult = tmp_27.a4u(new TypeInfo(tmp_28, tmp_29), this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              }
            } else {
              var tmp_31 = this;
              tmp_31.c8c_1 = Companion_instance;
              this.n8_1 = 5;
              suspendResult = mapApiErrorResponse(this.s8b_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }
          } else {
            var tmp_32 = this;
            var it = this.n8b_1;
            var exception_0 = Companion_instance_0.b2u(it);
            tmp_32.o8b_1 = new Result(_Result___init__impl__xyqfz8(createFailure(exception_0)));
            this.n8_1 = 12;
            continue $sm;
          }

        case 5:
          var tmp4 = suspendResult;
          var tmp_33 = this;
          this.c8c_1;
          tmp_33.u8b_1 = _Result___init__impl__xyqfz8(createFailure(tmp4));
          this.n8_1 = 11;
          continue $sm;
        case 6:
          var tmp2 = suspendResult instanceof JsonElement ? suspendResult : THROW_CCE();
          var tmp_34 = this;
          var tmp$ret$0;
          l$ret$1: do {
            var json = get_sharedJson();
            var this_1 = serializer(createKType(getKClass(KtList), arrayOf([createInvariantKTypeProjection(createKType(getKClass(ApiTimeOff), arrayOf([]), false))]), false));
            var serializer_0 = isInterface(this_1, KSerializer) ? this_1 : THROW_CCE();
            var tmp_35;
            if (tmp2 instanceof JsonObject) {
              tmp_35 = tmp2.c3p('data');
            } else {
              tmp_35 = false;
            }
            if (tmp_35) {
              var dataValue = getValue(tmp2, 'data');
              var tmp_36;
              if (dataValue instanceof JsonObject) {
                tmp_36 = true;
              } else {
                if (dataValue instanceof JsonArray) {
                  tmp_36 = equals(serializer_0.xn().op(), LIST_getInstance());
                } else {
                  tmp_36 = false;
                }
              }
              var shouldAttemptUnwrap = tmp_36;
              if (shouldAttemptUnwrap) {
                try {
                  tmp$ret$0 = json.s5z(serializer_0, dataValue);
                  break l$ret$1;
                } catch ($p) {
                  if ($p instanceof SerializationException) {
                    var e = $p;
                  } else {
                    throw $p;
                  }
                }
              }
            }
            tmp$ret$0 = json.s5z(serializer_0, tmp2);
          }
           while (false);
          tmp_34.x8b_1 = tmp$ret$0;
          this.n8_1 = 8;
          continue $sm;
        case 7:
          var tmp_37 = this;
          tmp_37.x8b_1 = (!(suspendResult == null) ? isInterface(suspendResult, KtList) : false) ? suspendResult : THROW_CCE();
          this.n8_1 = 8;
          continue $sm;
        case 8:
          var tmp1 = this.x8b_1;
          var tmp_38 = this;
          this.w8b_1;
          tmp_38.v8b_1 = _Result___init__impl__xyqfz8(tmp1);
          this.o8_1 = 13;
          this.n8_1 = 10;
          continue $sm;
        case 9:
          this.o8_1 = 13;
          var tmp_39 = this.q8_1;
          if (tmp_39 instanceof CancellationException) {
            var e_0 = this.q8_1;
            var tmp_40 = this;
            throw e_0;
          } else {
            var tmp_41 = this.q8_1;
            if (tmp_41 instanceof Error) {
              var e_1 = this.q8_1;
              var tmp_42 = this;
              tmp_42.v8b_1 = _Result___init__impl__xyqfz8(createFailure(e_1));
              this.n8_1 = 10;
              continue $sm;
            } else {
              throw this.q8_1;
            }
          }

        case 10:
          this.o8_1 = 13;
          var tmp_43 = this;
          var this_2 = this.v8b_1;
          var exception_1 = Result__exceptionOrNull_impl_p6xea9(this_2);
          var tmp_44;
          if (exception_1 == null) {
            var tmp_45 = _Result___get_value__impl__bjfvqg(this_2);
            var value_0 = (tmp_45 == null ? true : !(tmp_45 == null)) ? tmp_45 : THROW_CCE();
            tmp_44 = new Result(_Result___init__impl__xyqfz8(value_0));
          } else {
            var exception_2 = new UnexpectedApiResponse(exception_1);
            tmp_44 = new Result(_Result___init__impl__xyqfz8(createFailure(exception_2)));
          }

          tmp_43.u8b_1 = tmp_44.ul_1;
          this.n8_1 = 11;
          continue $sm;
        case 11:
          this.o8b_1 = new Result(this.u8b_1);
          this.n8_1 = 12;
          continue $sm;
        case 12:
          return this.o8b_1;
        case 13:
          throw this.q8_1;
      }
    } catch ($p) {
      var e_2 = $p;
      if (this.o8_1 === 13) {
        throw e_2;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e_2;
      }
    }
   while (true);
};
function TimeOffRemoteSource(apiClient, sessionDataProvider) {
  this.v89_1 = apiClient;
  this.w89_1 = sessionDataProvider;
}
protoOf(TimeOffRemoteSource).x89 = function (status, $completion) {
  var tmp = new $getTimeOffRequestsCOROUTINE$3(this, status, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  var tmp_0 = tmp.v8();
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    return tmp_0;
  return tmp_0;
};
function get_timeOffModule() {
  _init_properties_TimeOffModule_kt__uw8b9g();
  return timeOffModule;
}
var timeOffModule;
function timeOffModule$lambda($this$module) {
  _init_properties_TimeOffModule_kt__uw8b9g();
  // Inline function 'org.koin.core.module.Module.factory' call
  var tmp2 = timeOffModule$lambda$lambda;
  // Inline function 'org.koin.core.module.Module.factory' call
  // Inline function 'org.koin.core.module._factoryInstanceFactory' call
  var scopeQualifier = Companion_getInstance_1().s1a_1;
  // Inline function 'org.koin.core.definition._createDefinition' call
  var kind = Kind_Factory_getInstance();
  var secondaryTypes = emptyList();
  var def = new BeanDefinition(scopeQualifier, getKClass(TimeOffRemoteSource), null, tmp2, kind, secondaryTypes);
  var factory = new FactoryInstanceFactory(def);
  $this$module.p1c(factory);
  new KoinDefinition($this$module, factory);
  // Inline function 'org.koin.core.qualifier.named' call
  var tmp4 = new TypeQualifier(getKClass(TimeOff));
  // Inline function 'org.koin.core.module.Module.single' call
  // Inline function 'org.koin.core.module._singleInstanceFactory' call
  var definition = timeOffModule$lambda$lambda_0;
  var scopeQualifier_0 = Companion_getInstance_1().s1a_1;
  // Inline function 'org.koin.core.definition._createDefinition' call
  var kind_0 = Kind_Singleton_getInstance();
  var secondaryTypes_0 = emptyList();
  var def_0 = new BeanDefinition(scopeQualifier_0, getKClass(IListLocalSource), tmp4, definition, kind_0, secondaryTypes_0);
  var factory_0 = new SingleInstanceFactory(def_0);
  $this$module.p1c(factory_0);
  if (false || $this$module.i1c_1) {
    $this$module.r1c(factory_0);
  }
  new KoinDefinition($this$module, factory_0);
  // Inline function 'org.koin.core.module.Module.single' call
  // Inline function 'org.koin.core.module._singleInstanceFactory' call
  var definition_0 = timeOffModule$lambda$lambda_1;
  var scopeQualifier_1 = Companion_getInstance_1().s1a_1;
  // Inline function 'org.koin.core.definition._createDefinition' call
  var kind_1 = Kind_Singleton_getInstance();
  var secondaryTypes_1 = emptyList();
  var def_1 = new BeanDefinition(scopeQualifier_1, getKClass(TimeOffRepository), null, definition_0, kind_1, secondaryTypes_1);
  var factory_1 = new SingleInstanceFactory(def_1);
  $this$module.p1c(factory_1);
  if (false || $this$module.i1c_1) {
    $this$module.r1c(factory_1);
  }
  var tmp = new KoinDefinition($this$module, factory_1);
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$13 = [getKClass(ITimeOffAccessor), getKClass(ITimeOffMutator)];
  binds(tmp, tmp$ret$13);
  return Unit_instance;
}
function timeOffModule$lambda$lambda($this$factory, it) {
  _init_properties_TimeOffModule_kt__uw8b9g();
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp = $this$factory.q1d(getKClass(Client), null, null);
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp$ret$1 = $this$factory.q1d(getKClass(ISessionDataProvider), null, null);
  return new TimeOffRemoteSource(tmp, tmp$ret$1);
}
function timeOffModule$lambda$lambda_0($this$single, it) {
  _init_properties_TimeOffModule_kt__uw8b9g();
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp$ret$0 = $this$single.q1d(getKClass(ICache), null, null);
  return new SimpleListCacheLocalSource('time_off', tmp$ret$0);
}
function timeOffModule$lambda$lambda_1($this$single, it) {
  _init_properties_TimeOffModule_kt__uw8b9g();
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp = $this$single.q1d(getKClass(TimeOffRemoteSource), null, null);
  // Inline function 'org.koin.core.qualifier.named' call
  // Inline function 'org.koin.core.scope.Scope.get' call
  var qualifier = new TypeQualifier(getKClass(TimeOff));
  var tmp$ret$2 = $this$single.q1d(getKClass(IListLocalSource), qualifier, null);
  return new TimeOffRepository(tmp, tmp$ret$2);
}
var properties_initialized_TimeOffModule_kt_cigzoi;
function _init_properties_TimeOffModule_kt__uw8b9g() {
  if (!properties_initialized_TimeOffModule_kt_cigzoi) {
    properties_initialized_TimeOffModule_kt_cigzoi = true;
    timeOffModule = module_0(VOID, timeOffModule$lambda);
  }
}
function ITimeOffAccessor() {
}
function TimeOff(id) {
  this.y89_1 = id;
}
protoOf(TimeOff).toString = function () {
  return 'TimeOff(id=' + this.y89_1.toString() + ')';
};
protoOf(TimeOff).hashCode = function () {
  return this.y89_1.hashCode();
};
protoOf(TimeOff).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof TimeOff))
    return false;
  var tmp0_other_with_cast = other instanceof TimeOff ? other : THROW_CCE();
  if (!this.y89_1.equals(tmp0_other_with_cast.y89_1))
    return false;
  return true;
};
function ITimeOffMutator() {
}
//region block: post-declaration
protoOf($serializer).qz = typeParametersSerializers;
//endregion
//region block: init
Companion_instance_1 = new Companion();
//endregion
//region block: exports
export {
  get_timeOffModule as get_timeOffModule22auvlvjqtn9g,
  ITimeOffAccessor as ITimeOffAccessor2x87raxwv9n68,
  ITimeOffMutator as ITimeOffMutator1zilu5t06rd0m,
};
//endregion

